import Joi from 'joi';

const stringBoolean = ['ano', 'ne'];

export default Joi.object({
	adult: Joi.number()
		.positive()
		.min(1)
		.error(() => ({
			message: 'Počet dospělých osob musí být celé kladné číslo.',
		})),
	children6: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Počet dětí do 6 roků musí být celé kladné číslo.',
		})),
	children15: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Počet dětí 6 – 15 roků musí být celé kladné číslo.',
		})),
	children26: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Počet dětí ve věku od 15 do 26 let (studující) musí být celé kladné číslo.',
		})),
	income: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Průměrný měsíční příjem musí být celé kladné číslo.',
		})),
	allowance: Joi.valid(stringBoolean),
});
